exports = module.exports = require("../../../node_modules/_css-loader@0.26.4@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".alanModal[data-v-1e85bc05]{width:0;height:0;overflow:hidden}.defaultModal .ivu-modal-content .ivu-modal-body .defaultModal_bottom .ok[data-v-1e85bc05]{color:#f85252}.modal_orderDetail .ivu-modal-content[data-v-1e85bc05]{background:#fff}.modal_orderDetail .ivu-modal-body .tab .active[data-v-1e85bc05],.modal_orderDetail .ivu-modal-header[data-v-1e85bc05]{background:#f85252}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/_css-loader@0.26.4@css-loader?minimize!./~/_vue-loader@11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-1e85bc05","scoped":true,"hasInlineConfig":false}!./~/_less-loader@4.1.0@less-loader/dist/cjs.js!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./src/components/lotteryRefactoring/alanModal.vue
// module id = 758
// module chunks = 9